import { render } from "./DecomposeModal.vue?vue&type=template&id=ffeb59cc&scoped=true"
import script from "./DecomposeModal.vue?vue&type=script&lang=js"
export * from "./DecomposeModal.vue?vue&type=script&lang=js"

import "./DecomposeModal.vue?vue&type=style&index=0&id=ffeb59cc&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-ffeb59cc"]])

export default __exports__